import React from 'react';
import FeedTroughMaintenanceManagementRouter from './FeedTroughMaintenanceManagementRouter';

export default function FeedTroughMaintenanceManagementPage() {
  return <FeedTroughMaintenanceManagementRouter />;
}
